import Vue from "vue";
import Router from "vue-router";

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/resume/:userId",
    component: () => import("@/views/resume/index"),
    name: "Resume",
    hidden: true,
    props: true,
    meta: { title: "简历" }
  },
  {
    path: "/queryCertificate",
    component: () => import("@/views/queryCertificate/index"),
    name: "QueryCertificate",
    hidden: true,
    meta: { title: "证书查询" }
  },
  { path: "/401", component: () => import("@/views/error/401"), hidden: true },
  { path: "/404", component: () => import("@/views/error/404"), hidden: true },
  {
    path: "",
    component: Layout,
    redirect: "dashboard",
    hidden: true,
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "dashboard",
        hidden: true,
        meta: {
          title: "首页",
          componentName: "dashboard",
          icon: "dashboard",
          noCache: true
        }
      }
    ]
  },
  {
    path: "/userInfo",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "editUser",
        component: () => import("@/views/user/userInfo/edit"),
        name: "editUser",
        hidden: true,
        meta: {
          title: "编辑用户",
          componentName: "editUser",
          icon: "dashboard",
          noCache: true
        }
      }
    ]
  }
];

export const defaultRouterMap = constantRouterMap.concat();

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});
